<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin" style="min-width: 30vw;">
            <q-card-section>
                <img src="../../img/logo.png" class="full-width bg-primary" style="padding: 40px;">
            </q-card-section>
            <q-form ref="modelEmailForm" v-show="model.LoginScreen == loginScreenType.Email">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <q-input dense outlined v-model="model.LoginData.Email" label="Email Address" lazy-rules="ondemand" @keydown.enter.prevent ="onNextClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-form ref="modelPasswordForm" v-show="model.LoginScreen == loginScreenType.Password">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <div>Enter your password</div>
                                <div>{{ model.LoginData.Email }}</div>
                            </div>
                            <div class="col-6">
                                <div><a href="#" @click="onBackClick()">Wrong email?</a></div>
                            </div>
                            <div class="col-6">
                                <div><a href="#" @click="onForgotPasswordClick()">Forgot your password?</a></div>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.LoginData.Password" type="password" label="Password" lazy-rules="ondemand" @keydown.enter.prevent ="onSignInClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-form ref="modelNewPasswordForm" v-show="model.LoginScreen == loginScreenType.NewPasswordAndProfile">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <div>Please change password and complete your profile</div>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.NewPasswordData.Password" type="password" label="New Password" lazy-rules="ondemand" @keydown.enter.prevent ="onNewPasswordSendClick"
                                         :rules="[val => val && val.length > 0 || 'Required', val=>isPasswordValid(val)|| 'Password must contain minimum twelve characters, at least one uppercase letter, one lowercase letter, one number and one special character']">
                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.NewPasswordData.ConformPassword" type="password" label="Confirm Password" lazy-rules="ondemand" @keydown.enter.prevent ="onNewPasswordSendClick"
                                         :rules="[val => val && val.length > 0 || 'Required', val => val==model.NewPasswordData.Password || 'Password is not matched']">
                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.NewPasswordData.GivenName" label="Given Name" lazy-rules="ondemand" @keydown.enter.prevent ="onNewPasswordSendClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.NewPasswordData.FamilyName" label="Family Name" lazy-rules="ondemand" @keydown.enter.prevent ="onNewPasswordSendClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-form ref="modelForgotPasswordInitiateForm" v-show="model.LoginScreen == loginScreenType.ForgotPasswordInitiate">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <div>Enter your email below and we will send a message to reset your password</div>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.ForgotPasswordInitiateData.Email" label="Email" lazy-rules="ondemand" @keydown.enter.prevent ="onForgotPasswordInitiateClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-form ref="modelForgotPasswordConfirmForm" v-show="model.LoginScreen == loginScreenType.ForgotPasswordConfirm">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <div>We have sent a password reset code by email. Enter it below to reset your password</div>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.ForgotPasswordConfirmData.ConfirmationCode" label="Code" lazy-rules="ondemand" @keydown.enter.prevent ="onForgotPasswordConfirmClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.ForgotPasswordConfirmData.Password" type="password" label="New Password" lazy-rules="ondemand" @keydown.enter.prevent ="onForgotPasswordConfirmClick"
                                         :rules="[val => val && val.length > 0 || 'Required', val=>isPasswordValid(val)|| 'Password must contain minimum twelve characters, at least one uppercase letter, one lowercase letter, one number and one special character']">
                                </q-input>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.ForgotPasswordConfirmData.ConformPassword" type="password" label="Confirm Password" lazy-rules="ondemand" @keydown.enter.prevent ="onForgotPasswordConfirmClick"
                                         :rules="[val => val && val.length > 0 || 'Required', val => val==model.ForgotPasswordConfirmData.Password || 'Password is not matched']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-form ref="modelSoftwareTokenForm" v-show="model.LoginScreen == loginScreenType.SoftwareToken">
                <q-card-section class="text-center q-pt-none">
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <div>Please enter the code form your passcode app</div>
                            </div>
                            <div class="col-12">
                                <q-input dense outlined v-model="model.SoftwareTokenData.Token" label="Code" lazy-rules="ondemand" @keydown.enter.prevent ="onSoftwareTokenSendClick"
                                         :rules="[val => val && val.length > 0 || 'Required']">
                                </q-input>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-form>
            <q-card-section class="text-center q-pt-none" v-show="model.DisplayErrors">
                <div class="text-negative">{{ model.ErrorMessage}}</div>
            </q-card-section>
            <q-card-section class="text-center">
                <q-btn color="primary" label="Next" no-caps v-show="model.LoginScreen == loginScreenType.Email" @click="onNextClick()"></q-btn>
                <q-btn color="primary" label="Sign in" no-caps v-show="model.LoginScreen == loginScreenType.Password" @click="onSignInClick()"></q-btn>
                <q-btn color="primary" label="Update" no-caps v-show="model.LoginScreen == loginScreenType.NewPasswordAndProfile" @click="onNewPasswordSendClick()"></q-btn>
                <q-btn color="primary" label="Send" no-caps v-show="model.LoginScreen == loginScreenType.SoftwareToken" @click="onSoftwareTokenSendClick()"></q-btn>
                <q-btn color="primary" label="Reset my password" no-caps v-show="model.LoginScreen == loginScreenType.ForgotPasswordInitiate" @click="onForgotPasswordInitiateClick()"></q-btn>
                <q-btn color="primary" label="Change Password" no-caps v-show="model.LoginScreen == loginScreenType.ForgotPasswordConfirm" @click="onForgotPasswordConfirmClick()"></q-btn>
            </q-card-section>
            <q-card-section class="text-center q-pt-none" v-show="model.LoginScreen == loginScreenType.Password && model.IdentityProviders.length > 0">
                <div>or sign in with</div>
                <template v-for="(providerName, providerIndex) in model.IdentityProviders">
                    <q-btn color="primary" :label="providerName" no-caps @click="onSignInWithExternalProvider(providerName)"></q-btn>
                </template>
            </q-card-section>
            <q-card-section class="text-center q-pt-none" v-show="model.LoginScreen == loginScreenType.Email">
                <div class="text-caption">Don't have an account yet? Please contact support.</div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    export { default } from './logindialog.js'
</script>